export function outOfPolicyStatusStyle(status) {
    if (status === 1 || status === 2) {
        return 'price-restriction-warning';
    } else if (status === 3 || status === 4 || status === 5) {
        return 'price-restriction';
    }
        return '';
}



// WEBPACK FOOTER //
// ./src/app/modules/common/enum/out-of-policy-status-style.js